import React, { useContext, useEffect, useState } from 'react'
import './Listing.css'
import { Container, Row } from 'react-bootstrap'
import Header from '../Header'
import Filter from './Filter'
import List from './List'
import { LocationContext } from '../Context/Location'
import { useParams } from 'react-router-dom'
import { FilterContext } from '../Context/FilterContext'


const restUlr = `https://zomatourl.herokuapp.com/filter`;


const Listing = () => {
  const { locations } = useContext(LocationContext)
  const [restaurants, setRestaurants] = useState("")
  const params = useParams()
  const mealId = params.id;
  
  useEffect(() => {
    getRestaurants();
  },[])

  const getRestaurants = () => {
    fetch(`${restUlr}/${mealId}`, { method: "GET" })
      .then(res => res.json())
      .then(data => {
        setRestaurants(data)
      })
      .catch(err => {
        console.log(err);
      })
  }

  return (
    <React.Fragment>
      <Header />
      <Container style={{ padding: "30px 20px" }}>
        <Row >
            <h1 className='pb-4'>Breakfast Places in Mumbai</h1>
          <FilterContext.Provider value={{ restaurants, setRestaurants }}>
            <Filter locations={locations} />
            <List locations={locations} />
          </FilterContext.Provider>
        </Row>
      </Container>
    </React.Fragment>
  )
}

export default Listing